module.exports = __webpack_public_path__ + "fonts/OpenSans-SemiBoldItalic.15751881.ttf";